import React from 'react';
import { CheckIcon, TimerIcon, UserCheckIcon, LockIcon } from 'lucide-react';
import { actionLevels } from '../../data/levels';
import type { ActionLevel } from '../../types/anna';
const styles: Record<ActionLevel, {
  className: string;
  icon: typeof CheckIcon;
}> = {
  zelf: {
    className: 'border-white/15 bg-white/[0.04] text-ink-soft',
    icon: CheckIcon
  },
  tenzijBezwaar: {
    className: 'border-accent/40 bg-accent/10 text-accent',
    icon: TimerIcon
  },
  naOk: {
    className: 'border-transparent bg-ink text-night-950',
    icon: UserCheckIcon
  },
  nooit: {
    className: 'border-dashed border-white/25 bg-transparent text-ink-muted',
    icon: LockIcon
  }
};
export function LevelBadge({
  level,
  size = 'sm'
}: {
  level: ActionLevel;
  size?: 'sm' | 'wall';
}) {
  const {
    className,
    icon: Icon
  } = styles[level];
  const label = actionLevels.find(l => l.id === level)?.label ?? level;
  const sizeClass = size === 'wall' ? 'gap-2 px-3.5 py-1 text-[22px]' : 'gap-1.5 px-2.5 py-1 text-[12px]';
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full border font-semibold ${sizeClass} ${className}`} data-id="element-1155" data-mp="2mwp7f6pm19j1">
      <Icon className={size === 'wall' ? 'h-5 w-5' : 'h-3.5 w-3.5'} strokeWidth={2} aria-hidden data-id="element-1156" data-mp="2ruic1vb9lvh7" />
      {label}
    </span>;
}